import React from 'react'
import { isString, showModal } from './all'

export const disclosures = (arg) => {
    let p = Object.assign(
        { view: 'disclosures' },
        isString(arg) ? { html: arg } : arg)
    showModal(p)
}

export const Disclosures = ({
    label = 'Disclosures',
    html = '',
    dataModule='',
    dataCategory='',
    dataName = 'twd-disclosures-link',
    modalClass ='modal-dialog modal-md',
    title='Important Disclosures',
}={}) => {

    return <button
        { ...(dataModule ? {'data-module':dataModule} : {}) }
        { ...(dataCategory ? {'data-category':dataCategory} : {}) }
        data-name={dataName}
        className='btn-link'
        style={{cursor:'pointer'}}
        onClick={(e) => disclosures({html, modalClass, title, source:e.target,})}
    >{label
        ? label
        : <i style={{marginLeft:'5px'}}
            className="text-muted material-icons"
            aria-hidden="true">info_outline</i>
    }</button>
}


// WEBPACK FOOTER //
// ./src/twd/disclosures.js